// dependencies
import { Map, Record } from "immutable";
import React from "react";
import { connect } from "react-redux";

// components
import Modal from "./components/Modal";

// actions
import { CloseModal } from "../../actions/modals.actions";

import PropTypes from "../../lib/prop-types";

class Modals extends React.Component {
	static propTypes = {
		closeModal: PropTypes.func.isRequired,
		modal: PropTypes.oneOfType([PropTypes.instanceOf(Map), PropTypes.instanceOf(Record)]),
	};

	static defaultProps = {
		modal: null,
	};

	componentDidMount() {}

	render() {
		const { modal } = this.props;

		if (!modal) {
			return <div />;
		}

		const onOk = () => {
			this.props.closeModal();
			modal.get("action")();
		};

		const modalComponent = (
			<Modal
				message={modal.get("message")}
				onOK={onOk}
				onClose={this.props.closeModal}
				onCancel={this.props.closeModal}
				options={modal.get("options") || []}
			/>
		);

		return (
			<section className="component-modals-container">
				<section className="modal-wrapper">{modalComponent}</section>
			</section>
		);
	}
}

const mapStateToProps = (state) => ({
	modal: state.modals.get("activeModal"),
});

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(CloseModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
